export const CHAT_CHAT_MESSAGE_QUERY = `
  content
  createdAt
  id
  isSeen
  senderSwapRequest
  type
  updatedAt
`;
